 

import React from "react";

import { Link } from "react-router-dom";
import usePermissions from "../../components/permissions/permission";

const Job_nav = () => {
  const { hasPermission } = usePermissions();
  const jobData = [
    {
      id: 1,
      header: "Create Job",

      headerClasses: "text-black",
      linkTo: "/create-job",
      permissionId: 1340,
    },
    {
      id: 2,
      header: "Pending Job",

      headerClasses: "text-black",
      linkTo: "/pending-job",
      permissionId: 1350,
    },
    {
      id: 3,
      header: "Approved Job",

      headerClasses: "text-black",
      linkTo: "/created-job",
      permissionId: 1360,
    },
    {
      id: 4,
      header: "Rejected Job",

      headerClasses: "text-black",
      linkTo: "/rejected-job",
      permissionId: 1370,
    },
  ];

  return (
    <div className="bg-background overflow-y-auto h-screen">
      <p className="text-[25px] font-sans ml-6 mt-6 font-bold text-[#797C80] ">
        Job
      </p>

      {/* Cards with "Click Here" buttons */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-12 mt-[10%] mx-6 ">
        {jobData.map((card) =>
          hasPermission(card.permissionId) ? (
            <Link key={card.id} to={card.linkTo}>
              <div
                key={card.id}
                className="bg-white rounded-[32px] p-4 shadow-md flex flex-col justify-between"
              >
                <div>
                  {/* Conditional rendering based on header words */}
                  {card.header.split(" ").map((word, index) => (
                    <h2 key={index} className="text-[20px] font-semibold mb-1">
                      {word}
                    </h2>
                  ))}
                </div>
                <div className="flex justify-between items-center">
                  <button className="bg-primary w-[30%] mt-2 text-white font-bold py-2 px-4 rounded-[22px]">
                    Click Here
                  </button>

                  <div className="bg-primary w-[13px] h-[37px] rounded-xl"></div>
                </div>
              </div>
            </Link>
          ) : null
        )}
      </div>
    </div>
  );
};

export default Job_nav;
